import { InjectionToken } from '@angular/core';
import moment from 'moment';

export const getAdjustedDate = (date: string): Date => moment(date).toDate();

export type GetAdjustedDateProvider = (date: string) => Date;
export const GET_ADJUSTED_DATE =
    new InjectionToken('GET_ADJUSTED_DATE', {
        factory: () => getAdjustedDate
    });
